import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgInvoice = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m16.936 4.098.76-.364c.799-.382 1.723.2 1.722 1.086l-.01 12.256c0 2.423-1.348 3.924-3.766 3.924h-7.3C5.919 21 4.6 19.499 4.6 17.076L4.582 4.823a1.203 1.203 0 0 1 1.723-1.087l.754.361c.454.218.978.234 1.444.043l2.147-.875a3.57 3.57 0 0 1 2.7 0l2.142.875c.466.19.99.175 1.444-.042M9.172 9.803h2.889m-2.89 4.394h5.658"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgInvoice);
export default ForwardRef;
